<div class="dashboard-container">
    <h1>Products/Stock Dashboard</h1>
    
    <div class="dashboard-grid">
      <mat-card (click)="navigateTo('list')" class="dashboard-card">
        <mat-card-header>
          <mat-card-title>List Stock</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>View yearly and monthly sales comparisons</p>
        </mat-card-content>
      </mat-card>
  
      <mat-card class="dashboard-card" (click)="navigateTo('stockcount', 'Creams')">
        <mat-card-header>
          <mat-card-title>Stock Count Creams</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>List/Update stock count for Creams</p>
        </mat-card-content>
      </mat-card>
  
      <mat-card class="dashboard-card" (click)="navigateTo('stockcount', 'MH')">
        <mat-card-header>
          <mat-card-title>Stock Count MH</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>List/Update stock count for MH</p>
        </mat-card-content>
      </mat-card>

      <mat-card class="dashboard-card" (click)="navigateTo('stockcount', 'DISHD')">
        <mat-card-header>
          <mat-card-title>Stock Count DISHD</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>List/Update stock count for DISHD</p>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
  
  
  